import React from "react";
import { TextField, FormControl } from "@material-ui/core";

export default function CustomTextField({
  Name,
  Label,
  Change,
  Blur,
  Value,
  Error,
  Type,
  InputProps,
  FullWidth,
  Required,
}) {
  return (
    <FormControl fullWidth={FullWidth ?? false}>
      <TextField
        size="small"
        variant="outlined"
        name={Name}
        label={Label}
        onChange={Change}
        onBlur={Blur}
        type={Type ?? "text"}
        value={Value}
        error={Error}
        InputProps={InputProps}
        required={Required ?? false}
      />
    </FormControl>
  );
}
